module.exports = __webpack_public_path__ + "img/17869_L.cc03bc61.png";